/* helios-m-anim.js — mobile PDP below-the-line animation engine.
   Vanilla port of MScrollEngine.useMPinned (window-scroll branch) + MPhone3D,
   plus a per-section controller registry. Sections render markup with
   data-hm-section="<key>"; this boots each via window.HeliosM.sections[key](root).
   Card art reuses window.__ThriveCardArt (helios-cardart.js). 3D phone reuses
   iphone15.glb. One rAF per pinned section, idle-stop, window-scroll driven. */
(function () {
  if (window.HeliosM && window.HeliosM._booted) return;
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var ease = function (t) { return t * t * (3 - 2 * t); };

  // Stable viewport height. Lock it and only adopt a new value when the WIDTH
  // changes (orientation / real resize). On mobile the URL bar showing/hiding
  // changes window.innerHeight, which used to recompute every pinned track's
  // height mid-scroll — shifting total page height by thousands of px and
  // jumping the page when scrolling back up. Ignoring height-only changes fixes that.
  var _vw = window.innerWidth, _vh = window.innerHeight;
  window.addEventListener('resize', function () {
    if (window.innerWidth !== _vw) { _vw = window.innerWidth; _vh = window.innerHeight; }
  }, { passive: true });

  // ── Pin engine: faithful to useMPinned's window branch ───────────────
  // track grows to mult*vh; sticky pins at top:offset with height vh-offset;
  // progress 0..1 smoothed; rAF stops when settled, re-kicks on scroll.
  var MAXSTAGE = 780; // the source's pinned content height; the width-sized content
                      // (ring/phone/cards have fixed aspect) only fills this much —
                      // don't let the stage grow taller or it floats with dead zones.
  function pin(track, sticky, mult, offset, onProgress, opts) {
    var off = offset || 0, cap = (opts && opts.cap) || 0, cur = 0, lastSet = -1, active = false, raf = 0, running = true;
    function vh() { return _vh; }
    function measure() {
      var h = vh();
      track.style.height = (mult * h) + 'px';
      if (sticky) {
        var avail = h - off;
        var sh = cap ? Math.min(avail, cap) : avail;       // cap the stage at the design height
        sticky.style.height = sh + 'px';
        sticky.style.top = off + 'px';                      // TOP-align (right under the promo) like the source — no void above
      }
    }
    function trackTop() { return track.getBoundingClientRect().top + window.scrollY; }
    function near() { var h = vh(), r = track.getBoundingClientRect(); return r.bottom > -h && r.top < h * 2; }
    function loop() {
      var h = vh();
      var total = mult * h - h;
      var target = total > 0 ? clamp((window.scrollY - trackTop()) / total, 0, 1) : 0;
      cur += (target - cur) * 0.18;
      if (Math.abs(target - cur) < 0.0006) cur = target;
      if (Math.abs(cur - lastSet) > 0.0009) { lastSet = cur; try { onProgress(cur, h - off); } catch (e) {} }
      if (running && Math.abs(target - cur) > 0.0006) { raf = requestAnimationFrame(loop); }
      else active = false;
    }
    function kick() { if (!active && near()) { active = true; raf = requestAnimationFrame(loop); } }
    measure();
    setTimeout(function () { measure(); active = true; raf = requestAnimationFrame(loop); }, 250);
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', function () { measure(); kick(); });
    active = true; raf = requestAnimationFrame(loop);
    // prime a frame so the first paint isn't blank
    onProgress(0, vh() - off);
  }

  // ── MPhone3D: model-viewer iphone15.glb with the app screen textured on ──
  var MV_SRC = (window.HELIOS_M_GLB || '');           // asset_url injected by section
  function mountPhone(host, screen, fov) {
    if (host && host.querySelector('[data-hm-flatphone]')) {
      var fv = host.querySelector('video');
      if (fv) { try { fv.pause(); fv.muted = true; fv.removeAttribute('autoplay'); } catch (e) {} }
      return { setOrbit: function () {}, video: fv };
    }
    var mv = document.createElement('model-viewer');
    mv.setAttribute('src', MV_SRC);
    mv.setAttribute('alt', 'THRIVE app on iPhone');
    mv.setAttribute('loading', 'eager');
    mv.setAttribute('reveal', 'auto');
    mv.setAttribute('disable-zoom', '');
    mv.setAttribute('interaction-prompt', 'none');
    mv.setAttribute('camera-orbit', '180deg 90deg auto');
    mv.setAttribute('field-of-view', fov || '22deg');
    mv.setAttribute('exposure', '1.05');
    mv.setAttribute('shadow-intensity', '0.7');
    mv.setAttribute('shadow-softness', '0.9');
    mv.setAttribute('environment-image', 'neutral');
    mv.style.cssText = 'width:100%;height:100%;background:transparent;--poster-color:transparent;pointer-events:none;';
    host.appendChild(mv);
    var applied = false;
    function apply() {
      if (applied) return; applied = true;
      var mats = (mv.model && mv.model.materials) || [];
      var mat = mats.find(function (m) { return m.name === 'pIJKfZsazmcpEiU'; }) || mats[14] || mats.find(function (m) { return /screen|display/i.test(m.name || ''); });
      mv.createTexture(screen).then(function (tex) {
        if (!mat || !tex) return;
        try {
          var pbr = mat.pbrMetallicRoughness;
          pbr.baseColorTexture.setTexture(tex);
          pbr.setBaseColorFactor([1, 1, 1, 1]);
          if (pbr.setMetallicFactor) pbr.setMetallicFactor(0);
          if (pbr.setRoughnessFactor) pbr.setRoughnessFactor(0.5);
          if (mat.setEmissiveFactor) mat.setEmissiveFactor([1, 1, 1]);
          if (mat.emissiveTexture && mat.emissiveTexture.setTexture) mat.emissiveTexture.setTexture(tex);
        } catch (e) {}
      }).catch(function () {});
    }
    if (mv.loaded) apply(); else mv.addEventListener('load', apply, { once: true });
    return {
      el: mv,
      setOrbit: function (orbit) { mv.cameraOrbit = orbit; if (mv.jumpCameraToGoal) mv.jumpCameraToGoal(); }
    };
  }

  function cardHTML(type) { return (window.__ThriveCardArt ? window.__ThriveCardArt(type) : ''); }
  function fillCards(root) {
    root.querySelectorAll('[data-card-type]').forEach(function (el) {
      if (el.dataset.caFilled) return; el.dataset.caFilled = '1';
      el.innerHTML = cardHTML(el.getAttribute('data-card-type'));
    });
  }

  // Top offset for pinned stages = height of the exp5 sticky promo that sits at
  // the viewport top during deep scroll. Measure the promo's INNER content (its
  // outer height collapses to 0 via the slide-in transform when hidden, so the
  // inner padded block is the reliable height). Default 96.
  function topOffset() {
    if (typeof window.HELIOS_M_OFFSET === 'number') return window.HELIOS_M_OFFSET;
    var inner = document.querySelector('[data-exp5-sticky-promo] > div');
    var h = inner ? Math.round(inner.offsetHeight) : 0;
    return h > 24 ? h : 96;
  }
  // Bottom offset = the exp5 sticky add-to-cart bar that overlays the viewport
  // bottom during deep scroll. Keeps pinned content out from under it (and tightens
  // the stage so it doesn't leave dead space). Default 78.
  function bottomOffset() {
    if (typeof window.HELIOS_M_BOTTOM === 'number') return window.HELIOS_M_BOTTOM;
    var cart = document.querySelector('.exp5-sticky-cart');
    var h = cart ? Math.round(cart.getBoundingClientRect().height) : 0;
    return (h > 20 && h < 200) ? h : 78;
  }

  var HeliosM = window.HeliosM = window.HeliosM || {};
  HeliosM.pin = pin; HeliosM.mountPhone = mountPhone; HeliosM.fillCards = fillCards;
  HeliosM.u = { clamp: clamp, lerp: lerp, ease: ease };
  HeliosM.sections = HeliosM.sections || {};

  // ── Section: Meet Marco (key "marco") — single CSS-3D phone + tabbed videos ──
  HeliosM.sections.marco = function (root) {
    var BLUE2 = '#6f9bff';
    var CARDS = [
      { type: 'recovery', corner: 0, x: 20, y: 19, rot: -7, start: 0.10 },
      { type: 'coach',    corner: 2, x: 80, y: 19, rot: 6,  start: 0.20 },
      { type: 'ride',     corner: 1, x: 20, y: 66, rot: -6, start: 0.30 },
      { type: 'progress', corner: 3, x: 80, y: 66, rot: 6,  start: 0.40 }
    ];
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var header = root.querySelector('[data-hm-header]');
    var closing = root.querySelector('[data-hm-closing]');
    var caption = root.querySelector('[data-hm-caption]');
    var dots = [].slice.call(root.querySelectorAll('[data-hm-dot]'));
    var cardEls = [].slice.call(root.querySelectorAll('[data-hm-card]'));
    var phoneInner = root.querySelector('[data-hm-phoneinner]');
    var phoneWrap = root.querySelector('[data-hm-phone]');
    var videotabs = root.querySelector('[data-hm-videotabs]');
    var vtabs = [].slice.call(root.querySelectorAll('[data-hm-vtab]'));
    var vvids = [].slice.call(root.querySelectorAll('[data-hm-vvid]'));
    var vstarted = false;
    fillCards(root);
    function vselect(i) {
      vtabs.forEach(function (t, j) { var on = j === i; t.style.background = on ? '#205eee' : '#23262e'; t.style.color = on ? '#fff' : 'rgba(255,255,255,.92)'; });
      vvids.forEach(function (v, j) { var on = j === i; v.style.opacity = on ? 1 : 0; v.style.visibility = on ? 'visible' : 'hidden'; if (on) { try { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } catch (e) {} } else { try { v.pause(); } catch (e) {} } });
    }
    vtabs.forEach(function (t, i) { t.addEventListener('click', function () { vselect(i); }); });

    // Keep the phone clear of the tab row on SHORT viewports. The phone is
    // vertically centred in the stage; on a short screen its top rises into the
    // fixed tabs (top:46) and clips them. Cap the phone height so there is always
    // room for the tabs + a 14px gap above and a little breathing room below.
    // On tall screens the natural min(214px,54vw) wins and nothing changes.
    function fitPhone() {
      if (!phoneWrap) return;
      var stage = phoneWrap.parentElement;
      if (!stage) return;
      var stageH = stage.clientHeight;
      if (stageH < 120) return;
      var maxH = stageH - 124;                 // tabs (46+32) + 14 gap above, ~32 below
      var wByH = maxH * 417 / 851;
      var w = Math.min(214, window.innerWidth * 0.54, wByH);
      if (w > 120) phoneWrap.style.width = w + 'px';
    }
    fitPhone();
    setTimeout(fitPhone, 300);
    window.addEventListener('resize', fitPhone);

    pin(track, sticky, 9.5, topOffset(), function (p) {
      var retractAll = clamp((p - 0.70) / 0.10, 0, 1);
      var finalT = clamp((p - 0.82) / 0.08, 0, 1);   // phone squared-up + tabs by p=0.90, holds to p=1
      var revealed = 0;
      var lit = [false, false, false, false];
      for (var k = 0; k < CARDS.length; k++) { if (p >= CARDS[k].start + 0.02) { revealed++; lit[CARDS[k].corner] = true; } }
      // header fades out fast; closing fades in only after header is gone (no overlap)
      var headerOut = clamp(finalT * 1.7, 0, 1);
      header.style.opacity = 1 - headerOut;
      header.style.transform = 'translateY(' + (-headerOut * 12) + 'px)';
      var closeIn = clamp((finalT - 0.45) / 0.55, 0, 1);
      if (closing) {
        closing.style.visibility = closeIn > 0.01 ? 'visible' : 'hidden';
        closing.style.opacity = closeIn;
        closing.style.transform = 'translateY(' + ((1 - closeIn) * 12) + 'px)';
      }
      // flat 2D phone — no rotation; shifts down a touch at the finale to balance the tabs above
      if (phoneWrap) phoneWrap.style.transform = 'translate(-50%,-50%) translateY(' + (finalT * 30) + 'px)';
      // tabs reveal + autoplay once squared up
      if (videotabs) {
        videotabs.style.visibility = finalT > 0.01 ? 'visible' : 'hidden';
        videotabs.style.opacity = finalT;
        videotabs.style.pointerEvents = finalT > 0.55 ? 'auto' : 'none';
      }
      if (finalT > 0.92 && !vstarted) { vstarted = true; vselect(0); }
      dots.forEach(function (d, i) { d.style.width = (lit[i] ? 22 : 7) + 'px'; d.style.background = lit[i] ? BLUE2 : 'rgba(255,255,255,.2)'; });
      cardEls.forEach(function (el, i) {
        var c2 = CARDS[i];
        var rev = clamp((p - c2.start) / 0.13, 0, 1);
        var present = rev * (1 - retractAll);
        if (present <= 0.01) { el.style.opacity = 0; el.style.visibility = 'hidden'; return; }
        el.style.visibility = 'visible';
        var x = lerp(50, c2.x, present), y = lerp(50, c2.y, present), scc = lerp(0.18, 1, present);
        el.style.left = x + '%'; el.style.top = y + '%';
        el.style.transform = 'translate(-50%,-50%) scale(' + scc + ') rotate(' + (c2.rot * present) + 'deg)';
        el.style.opacity = clamp(present * 1.6, 0, 1);
        var lbl = el.querySelector('[data-hm-cardlabel]');
        if (lbl) lbl.style.opacity = clamp((present - 0.55) / 0.35, 0, 1);
      });
      if (caption) caption.style.opacity = clamp(Math.min(revealed / 2, 1) * (1 - retractAll), 0, 1) * (1 - finalT);
    }, {cap:MAXSTAGE});
  };

  // ── Section: King of Cycling Computers + ride-mode tail (key "king") ──
  HeliosM.sections.king = function (root) {
    var sm = function (t) { return t * t * (3 - 2 * t); };
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var glow = root.querySelector('[data-hm-glow]');
    var intro = root.querySelector('[data-hm-intro]');
    var label = root.querySelector('[data-hm-label]');
    var finish = root.querySelector('[data-hm-finish]');
    var phoneHost = root.querySelector('[data-hm-phone]');
    var dots = [].slice.call(root.querySelectorAll('[data-hm-dot]'));
    var cards = [].slice.call(root.querySelectorAll('[data-hm-card]'));
    // ride-mode tail elements — video lands ON the 3D phone's screen (no second phone)
    var rmhead = root.querySelector('[data-hm-rmhead]');
    var rmhint = root.querySelector('[data-hm-rmhint]');
    var rmscreen = root.querySelector('[data-hm-rmscreen]');
    var rmslots = [].slice.call(root.querySelectorAll('[data-hm-rslot]'));
    var rmcorners = [].slice.call(root.querySelectorAll('[data-hm-rmcorner]'));
    var rmclose = root.querySelector('[data-hm-rmclose]');
    var kingdots = root.querySelector('[data-hm-kingdots]');
    var open = false, lastPr = 0;
    fillCards(root);
    var phone = HeliosM.mountPhone(phoneHost, phoneHost.getAttribute('data-screen') || '', '21deg');
    var A1 = 0.36, A2 = 0.72;

    function applyCorners(pr) {
      rmcorners.forEach(function (b, i) {
        var rev = open ? 0 : clamp((pr - 0.45 - i * 0.09) / 0.18, 0, 1);
        b.style.visibility = rev > 0.01 ? 'visible' : 'hidden';
        b.style.opacity = rev;
        b.style.transform = 'translateY(' + ((1 - rev) * 8) + 'px) scale(' + lerp(0.85, 1, rev) + ')';
        b.style.pointerEvents = (!open && rev > 0.6) ? 'auto' : 'none';
      });
    }
    function showVideo(i) {
      open = true;
      if (rmscreen) { rmscreen.style.visibility = 'visible'; rmscreen.style.opacity = 1; }
      rmslots.forEach(function (s, j) {
        var on = j === i;
        s.style.visibility = on ? 'visible' : 'hidden';
        s.style.opacity = on ? 1 : 0;
        var v = s.querySelector('[data-hm-rvideo]');
        if (v) { if (on) { try { v.currentTime = 0; var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } catch (e) {} } else { try { v.pause(); } catch (e) {} } }
      });
      if (rmclose) rmclose.style.display = 'flex';
      if (rmhint) rmhint.style.opacity = 0;
      applyCorners(lastPr);
    }
    function hideVideo() {
      open = false;
      if (rmscreen) { rmscreen.style.opacity = 0; }
      rmslots.forEach(function (s) {
        s.style.opacity = 0;
        var v = s.querySelector('[data-hm-rvideo]'); if (v) { try { v.pause(); } catch (e) {} }
      });
      setTimeout(function () { if (!open && rmscreen) rmscreen.style.visibility = 'hidden'; }, 280);
      if (rmclose) rmclose.style.display = 'none';
      if (rmhint) rmhint.style.opacity = 1;
      applyCorners(lastPr);
    }
    rmcorners.forEach(function (b) { b.addEventListener('click', function () { showVideo(+b.getAttribute('data-hm-rmcorner')); }); });
    if (rmclose) rmclose.addEventListener('click', hideVideo);

    pin(track, sticky, 7.5, topOffset(), function (p) {
      var pk = clamp(p, 0, 1);                         // King now runs the full track
      var pr = 0;                                      // "Try the ride mode" tail hidden (kept in DOM, never revealed)
      lastPr = pr;
      if (pr < 0.18 && open) hideVideo();

      // ── existing King choreography (driven by pk) ──
      var introV = 1 - clamp(pk / 0.10, 0, 1);
      var p2 = clamp((pk - A1) / (A2 - A1), 0, 1), p3 = clamp((pk - A2) / (1 - A2), 0, 1);
      var dir = pk < A1 ? 1 : pk < A2 ? lerp(1, -1, sm(p2)) : lerp(-1, 0, sm(p3));
      var tx = -13 * dir;
      var az = 180 - 27 * dir, phi = 84 - 4 * Math.abs(dir);
      var fadeOut1 = 1 - clamp((pk - A1) / 0.10, 0, 1), fadeOut2 = 1 - clamp((pk - A2) / 0.10, 0, 1);
      if (glow) glow.style.left = (50 + tx * 0.7) + '%';
      intro.style.opacity = introV; intro.style.transform = 'translateY(' + (-(1 - introV) * 16) + 'px)';
      label.style.opacity = (1 - introV) * (1 - p3) * (1 - pr);
      // finish text fades out as the ride-mode heading comes in (they share the top)
      var fop = p3 * (1 - pr);
      finish.style.display = fop > 0.01 ? 'block' : 'none'; finish.style.opacity = fop; finish.style.transform = 'translateY(' + ((1 - p3) * 16) + 'px)';
      phoneHost.style.transform = 'translate(-50%,-50%) translateX(' + tx + '%)';  // GLB stays fully visible
      phone.setOrbit(az + 'deg ' + phi + 'deg auto');
      cards.forEach(function (el) {
        var wave = el.getAttribute('data-wave'), i = +el.getAttribute('data-i'), side = el.getAttribute('data-side'), y = +el.getAttribute('data-y');
        var rev = wave === '1' ? clamp((pk - 0.05 - i * 0.055) / 0.20, 0, 1) * fadeOut1 : clamp((pk - (A1 + 0.03) - i * 0.055) / 0.20, 0, 1) * fadeOut2;
        if (rev <= 0.01) { el.style.opacity = 0; el.style.visibility = 'hidden'; return; }
        el.style.visibility = 'visible';
        var tgtX = side === 'r' ? 74 : 26;
        var x = lerp(50, tgtX, rev), sc = lerp(0.3, 1, rev);
        el.style.left = x + '%'; el.style.top = y + '%';
        el.style.transform = 'translate(-50%,-50%) scale(' + sc + ')';
        el.style.opacity = clamp(rev * 1.4, 0, 1);
        var t = el.querySelector('[data-hm-cardtitle]'); if (t) t.style.opacity = clamp((rev - 0.5) / 0.4, 0, 1);
      });
      if (kingdots) kingdots.style.opacity = 1 - pr;
      dots.forEach(function (d, i) { var close = Math.max(0, 1 - Math.abs(pk * 2 - i)); d.style.width = (6 + close * 16) + 'px'; d.style.background = close > 0.35 ? '#2a6fdb' : 'rgba(15,20,34,.16)'; });

      // ── ride-mode tail (driven by pr) ──
      if (rmhead) { var hv = clamp(pr / 0.32, 0, 1); rmhead.style.visibility = hv > 0.01 ? 'visible' : 'hidden'; rmhead.style.opacity = hv; rmhead.style.transform = 'translateY(' + ((1 - hv) * -10) + 'px)'; }
      applyCorners(pr);
    }, {cap:MAXSTAGE});
  };

  // ── Section: Try the ride mode (key "ridemode") — grow + 4 corner video taps ──
  HeliosM.sections.ridemode = function (root) {
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var head = root.querySelector('[data-hm-rmhead]');
    var hint = root.querySelector('[data-hm-rmhint]');
    var wrap = root.querySelector('[data-hm-rmphonewrap]');
    var idle = root.querySelector('[data-hm-rmidle]');
    var corners = [].slice.call(root.querySelectorAll('[data-hm-rmcorner]'));
    var slots = [].slice.call(root.querySelectorAll('[data-hm-rslot]'));
    var closeBtn = root.querySelector('[data-hm-rmclose]');
    var open = false, lastP = 0;

    function applyCorners(p) {
      corners.forEach(function (b, i) {
        var rev = open ? 0 : clamp((p - 0.30 - i * 0.07) / 0.18, 0, 1);
        b.style.opacity = rev;
        b.style.transform = 'translateY(' + ((1 - rev) * 8) + 'px) scale(' + lerp(0.85, 1, rev) + ')';
        b.style.pointerEvents = (!open && rev > 0.6) ? 'auto' : 'none';
      });
    }
    function showVideo(i) {
      open = true;
      if (idle) idle.style.opacity = 0;
      slots.forEach(function (s, j) {
        var on = j === i;
        s.style.visibility = on ? 'visible' : 'hidden';
        s.style.opacity = on ? 1 : 0;
        var v = s.querySelector('[data-hm-rvideo]');
        if (v) { if (on) { try { v.currentTime = 0; var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } catch (e) {} } else { try { v.pause(); } catch (e) {} } }
      });
      if (closeBtn) closeBtn.style.display = 'flex';
      if (hint) hint.style.opacity = 0;
      applyCorners(lastP);
    }
    function hideVideo() {
      open = false;
      if (idle) idle.style.opacity = 1;
      slots.forEach(function (s) {
        s.style.opacity = 0;
        var v = s.querySelector('[data-hm-rvideo]'); if (v) { try { v.pause(); } catch (e) {} }
        setTimeout(function () { if (!open) s.style.visibility = 'hidden'; }, 300);
      });
      if (closeBtn) closeBtn.style.display = 'none';
      if (hint) hint.style.opacity = 1;
      applyCorners(lastP);
    }
    corners.forEach(function (b, i) { b.addEventListener('click', function () { showVideo(+b.getAttribute('data-hm-rmcorner')); }); });
    if (closeBtn) closeBtn.addEventListener('click', hideVideo);

    pin(track, sticky, 2.8, topOffset(), function (p) {
      lastP = p;
      var headIn = clamp(p / 0.18, 0, 1);
      head.style.opacity = headIn; head.style.transform = 'translateY(' + ((1 - headIn) * -10) + 'px)';
      var grow = ease(clamp((p - 0.06) / 0.36, 0, 1));
      if (wrap) wrap.style.transform = 'translate(-50%,-50%) scale(' + lerp(0.86, 1, grow) + ')';
      applyCorners(p);
    }, { cap: MAXSTAGE });
  };

  // ── Section: Ring showcase — 40-frame scrub + sensor callouts (key "ring") ──
  HeliosM.sections.ring = function (root) {
    var SENSORS = [
      { a: [56, 40], l: [66, 16], side: 'right' },
      { a: [60, 60], l: [66, 71], side: 'right' },
      { a: [44, 44], l: [34, 17], side: 'left' },
      { a: [50, 66], l: [34, 73], side: 'left' }
    ];
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var heading = root.querySelector('[data-hm-heading]');
    var stats = root.querySelector('[data-hm-stats]');
    var caption = root.querySelector('[data-hm-caption]');
    var box = root.querySelector('[data-hm-ringbox]');
    var canvas = root.querySelector('[data-hm-canvas]');
    var battery = root.querySelector('[data-hm-battery]');
    var batteryScale = root.querySelector('[data-hm-batteryscale]');
    var lines = [].slice.call(root.querySelectorAll('[data-hm-line]'));
    var nodes = [].slice.call(root.querySelectorAll('[data-hm-node]'));
    var dots2 = [].slice.call(root.querySelectorAll('[data-hm-dot2]'));
    var labels = [].slice.call(root.querySelectorAll('[data-hm-slabel]'));
    var FRAMES = window.HELIOS_M_RINGFRAMES || [];
    var imgs = FRAMES.map(function (s) { var im = new Image(); im.decoding = 'async'; im.src = s; return im; });
    var cx = canvas.getContext('2d');
    var lastFrame = -1, lastDrawn = -1;
    function paint(f) {
      var im = imgs[f];
      if (im && im.complete && im.naturalWidth) { try { cx.drawImage(im, 0, 0, canvas.width, canvas.height); lastDrawn = f; } catch (e) {} return; }
      // nearest already-decoded fallback so the canvas never blanks
      for (var d = 1; d < FRAMES.length; d++) {
        var lo = imgs[f - d], hi = imgs[f + d];
        if (lo && lo.complete && lo.naturalWidth) { try { cx.drawImage(lo, 0, 0, canvas.width, canvas.height); } catch (e) {} break; }
        if (hi && hi.complete && hi.naturalWidth) { try { cx.drawImage(hi, 0, 0, canvas.width, canvas.height); } catch (e) {} break; }
      }
      if (im) im.addEventListener('load', function () { if (f === lastFrame) { try { cx.drawImage(im, 0, 0, canvas.width, canvas.height); lastDrawn = f; } catch (e) {} } }, { once: true });
    }
    pin(track, sticky, 5.5, topOffset(), function (p) {
      var intro = clamp(p / 0.2, 0, 1);
      var introOp = 1 - clamp((p - 0.16) / 0.08, 0, 1);
      var rp = clamp((p - 0.2) / 0.8, 0, 1);
      var scrub = clamp(rp / 0.56, 0, 1);
      var frame = Math.round(Math.pow(scrub, 0.8) * 39);
      var reveal = clamp((rp - 0.56) / 0.34, 0, 1);
      var ringShiftY = lerp(-110, 18, clamp((p - 0.2) / 0.12, 0, 1));
      if (frame !== lastFrame) { lastFrame = frame; paint(frame); }
      heading.style.opacity = clamp((p - 0.2) / 0.08, 0, 1);
      stats.style.opacity = clamp((p - 0.24) / 0.1, 0, 1) * (1 - clamp((p - 0.54) / 0.08, 0, 1));
      caption.style.opacity = clamp((p - 0.24) / 0.1, 0, 1);
      box.style.transform = 'translateY(' + ringShiftY + 'px)';
      battery.style.display = introOp > 0.01 ? 'block' : 'none';
      battery.style.opacity = introOp;
      if (batteryScale) batteryScale.style.transform = 'translate(-50%,-50%) scale(' + (0.9 + intro * 0.1) + ')';
      for (var i = 0; i < SENSORS.length; i++) {
        var lp = clamp((reveal - i * 0.13) / 0.5, 0, 1);
        var node = clamp(lp / 0.26, 0, 1), line = clamp((lp - 0.24) / 0.46, 0, 1), pill = clamp((lp - 0.58) / 0.42, 0, 1);
        var s = SENSORS[i];
        var x2 = s.a[0] + (s.l[0] - s.a[0]) * line, y2 = s.a[1] + (s.l[1] - s.a[1]) * line;
        if (lines[i]) { lines[i].setAttribute('x2', x2); lines[i].setAttribute('y2', y2); lines[i].style.opacity = line > 0 ? 1 : 0; }
        if (nodes[i]) { nodes[i].style.opacity = node * 0.5; nodes[i].style.animation = node > 0.9 ? 'mrs-node 1.9s ease-out infinite' : 'none'; }
        if (dots2[i]) { dots2[i].style.transform = 'translate(-50%,-50%) scale(' + (0.4 + node * 0.6) + ')'; dots2[i].style.opacity = node; }
        if (labels[i]) { var onLeft = s.side === 'left'; labels[i].style.transform = 'translate(0,-50%) translateX(' + ((onLeft ? -1 : 1) * (3 + (1 - pill) * 5)) + 'px)'; labels[i].style.opacity = pill; }
      }
    }, {cap:MAXSTAGE});
  };

  // ── Section: Heart rate (key "heart") — not pinned; live bpm ticker ──
  HeliosM.sections.heart = function (root) {
    var bpm = root.querySelector('[data-hm-bpm]');
    if (bpm) setInterval(function () { bpm.textContent = 146 + Math.floor(Math.random() * 6); }, 1600);
  };

  // ── Section: Sleep & recovery — pinned 2-page cross-fade (key "sleep") ──
  HeliosM.sections.sleep = function (root) {
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var page1 = root.querySelector('[data-hm-page="1"]');
    var page2 = root.querySelector('[data-hm-page="2"]');
    var score = root.querySelector('[data-hm-sleepscore]');
    var ready = root.querySelector('[data-hm-readiness]');
    var hypno = [].slice.call(root.querySelectorAll('[data-hm-hypno]'));
    var radial = root.querySelector('[data-hm-radial]');
    var signals = [].slice.call(root.querySelectorAll('[data-hm-signal]'));
    var windows = [].slice.call(root.querySelectorAll('[data-hm-window]'));
    var ibars = [].slice.call(root.querySelectorAll('[data-hm-ibar]'));     // session interval bars (grow in)
    var sreveal = [].slice.call(root.querySelectorAll('[data-hm-sreveal]')); // session stats + Marco cue (fade up)
    var HT = { Deep: 96, Light: 70, REM: 54, Awake: 30 };
    pin(track, sticky, 5.5, topOffset(), function (p) {
      var a1 = clamp(p / 0.34, 0, 1);
      var tt = clamp((p - 0.42) / 0.16, 0, 1);
      var a2 = clamp((p - 0.60) / 0.34, 0, 1);
      if (page1) page1.style.transform = 'translateY(' + (-tt * 112) + '%)';
      if (page2) page2.style.transform = 'translateY(' + ((1 - tt) * 112) + '%)';
      if (score) score.textContent = Math.round(86 * a1);
      if (ready) ready.textContent = Math.round(92 * a1);
      hypno.forEach(function (b, j) {
        var br = clamp(a1 * 1.7 - j / hypno.length * 0.7, 0, 1);
        b.style.transform = 'scaleY(' + br + ')';
        b.style.opacity = (b.getAttribute('data-awake') ? 0.55 : 1) * clamp(br * 4, 0, 1);
      });
      if (radial) radial.style.opacity = clamp(a1 * 1.3, 0, 1);
      signals.forEach(function (s, j) {
        var bw = clamp(a2 * 1.5 - j * 0.12, 0, 1);
        var bar = s.querySelector('[data-hm-bar]'), val = s.querySelector('[data-hm-val]');
        if (bar) bar.style.width = (parseFloat(s.getAttribute('data-pct')) * bw) + '%';
        if (val) val.style.opacity = clamp(bw * 2, 0, 1);
      });
      windows.forEach(function (w, j) {
        var ro = clamp(a2 * 1.7 - j * 0.2, 0, 1);
        w.style.opacity = ro; w.style.transform = 'translateX(' + ((1 - ro) * -14) + 'px)';
      });
      // session card: interval bars grow first, then stats + Marco cue fade up
      ibars.forEach(function (b, j) {
        b.style.transform = 'scaleY(' + clamp(a2 * 1.9 - j * 0.05, 0, 1) + ')';
      });
      sreveal.forEach(function (el, j) {
        var ro = clamp(a2 * 1.6 - 0.55 - j * 0.22, 0, 1);
        el.style.opacity = ro; el.style.transform = 'translateY(' + ((1 - ro) * 8) + 'px)';
      });
    }, {cap:MAXSTAGE});
  };

  // ── Section: Cycling wellness — pinned phone screen cross-fade (key "wellness") ──
  HeliosM.sections.wellness = function (root) {
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var screens = [].slice.call(root.querySelectorAll('[data-hm-screen]'));
    var copies = [].slice.call(root.querySelectorAll('[data-hm-copy]'));
    var pills = [].slice.call(root.querySelectorAll('[data-hm-pill]'));
    var glow = root.querySelector('[data-hm-glow]');
    var eyebrow = root.querySelector('[data-hm-eyebrow]');
    var TINTS = pills.map(function (el) { return el.getAttribute('data-tint'); });
    var N = screens.length;
    pin(track, sticky, 6.5, topOffset(), function (p) {
      var cont = p * (N - 1);
      var active = clamp(Math.round(cont), 0, N - 1);
      var tint = TINTS[active];
      screens.forEach(function (s, i) { var o = clamp(1.35 - Math.abs(cont - i) / 0.55, 0, 1); s.style.opacity = o; s.style.transform = 'scale(' + (0.96 + o * 0.04) + ')'; });
      copies.forEach(function (c, i) { var o = clamp(1.3 - Math.abs(cont - i) / 0.5, 0, 1); c.style.opacity = o; c.style.transform = 'translateY(' + ((1 - o) * 16) + 'px)'; c.style.display = o <= 0.01 ? 'none' : 'block'; });
      pills.forEach(function (el, i) { var on = i === active; el.style.color = on ? '#0a0a0c' : 'rgba(255,255,255,.5)'; el.style.background = on ? el.getAttribute('data-tint') : 'transparent'; el.style.borderColor = on ? el.getAttribute('data-tint') : 'rgba(255,255,255,.1)'; });
      if (glow) glow.style.background = 'radial-gradient(ellipse, ' + tint + '22, transparent 60%)';
      if (eyebrow) eyebrow.style.color = tint;
    }, {cap:MAXSTAGE});
  };

  // ── Section: Built to last — pinned full-bleed photo cross-fade (key "built", NO offset) ──
  HeliosM.sections.built = function (root) {
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var photos = [].slice.call(root.querySelectorAll('[data-hm-photo]'));
    var claims = [].slice.call(root.querySelectorAll('[data-hm-claim]'));
    var dots = [].slice.call(root.querySelectorAll('[data-hm-dot]'));
    var N = photos.length;
    pin(track, sticky, 4.5, 0, function (p) {   // built uses top:0 (no chrome offset) per source
      var cont = p * (N - 1);
      photos.forEach(function (el, i) {
        var d = cont - i, o = clamp(1.25 - Math.abs(d) / 0.62, 0, 1);
        var zoom = 1.06 + clamp(d * 0.05, -0.05, 0.05) + (1 - o) * 0.04;
        el.style.opacity = o;
        var img = el.querySelector('img'); if (img) img.style.transform = 'scale(' + zoom + ')';
      });
      claims.forEach(function (c, i) { var o = clamp(1.3 - Math.abs(cont - i) / 0.5, 0, 1); c.style.opacity = o; c.style.transform = 'translateY(' + ((1 - o) * 18) + 'px)'; c.style.display = o <= 0.01 ? 'none' : 'block'; });
      dots.forEach(function (d, i) { var close = Math.max(0, 1 - Math.abs(cont - i)); d.style.width = (6 + close * 18) + 'px'; d.style.background = close > 0.35 ? '#fff' : 'rgba(255,255,255,.22)'; });
    });   // full-bleed: no bottom offset (photo covers the viewport)
  };

  // ── Section: Reviews wall — filter chips (key "reviews", not pinned) ──
  HeliosM.sections.reviews = function (root) {
    var chips = [].slice.call(root.querySelectorAll('[data-hm-chip]'));
    var cards = [].slice.call(root.querySelectorAll('[data-hm-review]'));
    function apply(f) {
      chips.forEach(function (c) { var on = c.getAttribute('data-filter') === f; c.style.background = on ? '#0f1422' : '#fff'; c.style.color = on ? '#fff' : '#0f1422'; c.style.borderColor = on ? '#0f1422' : '#e1e5ec'; });
      cards.forEach(function (card) {
        var r = card.getAttribute('data-rating'), crit = card.getAttribute('data-critique') === '1';
        var show = f === 'all' ? true : f === 'critique' ? crit : r === f;
        card.style.display = show ? 'flex' : 'none';
      });
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.getAttribute('data-filter')); }); });
    apply('all');
  };

  // ── Section: Community stories — scroll-snap rail + dots (key "community") ──
  HeliosM.sections.community = function (root) {
    var rail = root.querySelector('[data-hm-rail]');
    var dots = [].slice.call(root.querySelectorAll('[data-hm-cdot]'));
    if (!rail) return;
    function sync() {
      var w = rail.children[0] ? rail.children[0].offsetWidth + 14 : 1;
      var i = Math.max(0, Math.min(dots.length - 1, Math.round(rail.scrollLeft / w)));
      dots.forEach(function (d, j) { var on = j === i; d.style.width = on ? '26px' : '8px'; d.style.background = on ? '#2a6fdb' : '#d3d7df'; });
    }
    rail.addEventListener('scroll', sync, { passive: true });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { var card = rail.children[i]; if (card) rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft, behavior: 'smooth' }); }); });
    sync();
  };

  // ── Section: App preview — pinned horizontal scroll-jack (key "apppreview") ──
  // Section locks centered; vertical scroll translates the phone track sideways
  // through the screens, then releases. Reuses the window-scroll pin engine.
  HeliosM.sections.apppreview = function (root) {
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var rail = root.querySelector('[data-hm-apptrack]');
    if (!track || !sticky || !rail || !rail.children.length) return;
    var cards = [].slice.call(rail.children);
    // Cap each phone so it never clips top/bottom on short viewports. Phones are
    // aspect 9/19; bound their width by the available band height (minus the label
    // under each phone). On tall screens the natural min(216px,58vw) still wins.
    function fitPhones() {
      var area = rail.parentElement;
      if (!area) return;
      var H = area.clientHeight;
      if (H < 120) return;
      // baseline width
      var w = Math.min(216, window.innerWidth * 0.58);
      cards.forEach(function (c) { c.style.transform = ''; c.style.flex = '0 0 ' + w + 'px'; c.style.width = w + 'px'; });
      // these CSS-mockup phones are content-tall (taller than their aspect box), so a
      // width cap alone still clips. Scale each card down to fit the band height.
      cards.forEach(function (c) {
        var nat = c.offsetHeight;
        if (nat > H - 6) { c.style.transformOrigin = 'center center'; c.style.transform = 'scale(' + ((H - 6) / nat).toFixed(3) + ')'; }
      });
    }
    function center() {
      var vw = window.innerWidth;
      rail.style.paddingLeft = Math.max(8, (vw - cards[0].offsetWidth) / 2) + 'px';
      rail.style.paddingRight = Math.max(8, (vw - cards[cards.length - 1].offsetWidth) / 2) + 'px';
    }
    fitPhones(); center();
    setTimeout(function () { fitPhones(); center(); }, 300);
    window.addEventListener('resize', function () { fitPhones(); center(); });
    pin(track, sticky, 2.4, topOffset(), function (p) {
      var shift = Math.max(0, cards[cards.length - 1].offsetLeft - cards[0].offsetLeft);
      rail.style.transform = 'translateX(' + (-p * shift) + 'px)';
    }, { cap: MAXSTAGE });
  };

  // ── Section: Feature strip (key "featstrip") — DUMMY comparison ──────────
  // Bigger flat iPhones in a pinned horizontal scroll-jack; the phone nearest the
  // viewport centre scales up + brightens (focus motion) so it never reads as a
  // dead carousel. Independent per section (Marco strip + King strip each boot one).
  HeliosM.sections.featstrip = function (root) {
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var rail = root.querySelector('[data-hm-apptrack]');
    if (!track || !sticky || !rail || !rail.children.length) return;
    var cards = [].slice.call(rail.children);
    function fitPhones() {
      var area = rail.parentElement;
      if (!area) return;
      var H = area.clientHeight;
      if (H < 140) return;
      var w = Math.min(300, window.innerWidth * 0.80);
      cards.forEach(function (c) { c._fit = 1; c.style.flex = '0 0 ' + w + 'px'; c.style.width = w + 'px'; c.style.transformOrigin = 'center center'; });
      // these content-tall mock screens may exceed the band; scale to fit height.
      cards.forEach(function (c) {
        var nat = c.offsetHeight;
        if (nat > H - 4) c._fit = (H - 4) / nat;
      });
    }
    function center() {
      var vw = window.innerWidth;
      rail.style.paddingLeft = Math.max(8, (vw - cards[0].offsetWidth) / 2) + 'px';
      rail.style.paddingRight = Math.max(8, (vw - cards[cards.length - 1].offsetWidth) / 2) + 'px';
    }
    function focus() {
      var mid = window.innerWidth / 2;
      cards.forEach(function (c) {
        var r = c.getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - mid) / (window.innerWidth * 0.62);
        var f = clamp(1 - d, 0, 1);
        var sc = lerp(0.9, 1.0, f) * (c._fit || 1);
        c.style.transform = 'translateY(' + ((1 - f) * 12) + 'px) scale(' + sc.toFixed(3) + ')';
        c.style.opacity = (0.45 + f * 0.55).toFixed(2);
      });
    }
    fitPhones(); center(); focus();
    setTimeout(function () { fitPhones(); center(); focus(); }, 300);
    window.addEventListener('resize', function () { fitPhones(); center(); focus(); });
    pin(track, sticky, 2.8, topOffset(), function (p) {
      var shift = Math.max(0, cards[cards.length - 1].offsetLeft - cards[0].offsetLeft);
      rail.style.transform = 'translateX(' + (-p * shift) + 'px)';
      focus();
    }, { cap: MAXSTAGE });
  };

  // ── Section: Ride interactive (key "rideinteractive") — DUMMY tester ─────
  // One big centred phone auto-plays a clip; floating side chips seek the video to
  // a section + highlight + update the caption. Not pinned; plays when in view.
  HeliosM.sections.rideinteractive = function (root) {
    var video = root.querySelector('[data-hm-rivideo]');
    var chips = [].slice.call(root.querySelectorAll('[data-hm-richip]'));
    var caption = root.querySelector('[data-hm-ricaption]');
    function play() { if (!video) return; try { var p = video.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
    if (video) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) play(); else { try { video.pause(); } catch (er) {} } });
        }, { threshold: 0.3 }).observe(video);
      } else play();
    }
    function activate(chip) {
      chips.forEach(function (c) {
        var on = c === chip, acc = c.getAttribute('data-accent');
        c.style.background = on ? acc : 'rgba(10,14,24,.74)';
        c.style.borderColor = on ? acc : 'rgba(255,255,255,.18)';
        c.style.transform = on ? 'scale(1.07)' : 'scale(1)';
        c.style.boxShadow = on ? '0 12px 30px -8px ' + acc + 'cc' : '0 10px 26px -10px rgba(0,0,0,.7)';
        c.style.zIndex = on ? 7 : 6;
        var ic = c.querySelector('[data-hm-ic]'), mt = c.querySelector('[data-hm-mt]');
        if (ic) ic.style.color = on ? '#fff' : acc;       // accent icon → white on the filled active pill
        if (mt) mt.style.color = on ? 'rgba(255,255,255,.85)' : acc;
      });
      if (video) { var t = parseFloat(chip.getAttribute('data-seek')) || 0; try { if (isFinite(video.duration) && video.duration > 0) t = Math.min(t, video.duration - 0.1); video.currentTime = t; } catch (e) {} play(); }
      if (caption) caption.textContent = chip.getAttribute('data-caption') || '';
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { activate(c); }); });
    if (chips[0]) activate(chips[0]);
  };

  // ── Section: Marco tabs (key "marcotabs") — TRIAL ────────────────────────
  // 4 tabs; each tab = a panel with a phone + floating skill bubbles. Tab click
  // swaps the panel (and its clip); bubble click plays that skill's clip + lights
  // the bubble + updates the caption. Only the active panel's video plays.
  HeliosM.sections.marcotabs = function (root) {
    var tabs = [].slice.call(root.querySelectorAll('[data-mt-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-mt-panel]'));
    var caption = root.querySelector('[data-mt-caption]');
    var active = 0;
    function playVid(p) { var v = p && p.querySelector('[data-mt-video]'); if (v) { try { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } catch (e) {} } }
    function activateBubble(panel, bubble) {
      var bubbles = [].slice.call(panel.querySelectorAll('[data-mt-bubble]'));
      bubbles.forEach(function (b) {
        var on = b === bubble, acc = b.getAttribute('data-accent');
        b.style.background = on ? acc : 'rgba(10,14,24,.74)';
        b.style.borderColor = on ? acc : 'rgba(255,255,255,.18)';
        b.style.transform = on ? 'scale(1.07)' : 'scale(1)';
        b.style.boxShadow = on ? '0 12px 30px -8px ' + acc + 'cc' : '0 10px 26px -10px rgba(0,0,0,.7)';
        b.style.zIndex = on ? 7 : 6;
        var ic = b.querySelector('[data-mt-ic]'), mt = b.querySelector('[data-mt-mt]');
        if (ic) ic.style.color = on ? '#fff' : acc;
        if (mt) mt.style.color = on ? 'rgba(255,255,255,.85)' : acc;
      });
      var v = panel.querySelector('[data-mt-video]');
      if (v) { var t = parseFloat(bubble.getAttribute('data-seek')) || 0; try { if (isFinite(v.duration) && v.duration > 0) t = Math.min(t, v.duration - 0.1); v.currentTime = t; } catch (e) {} playVid(panel); }
      if (caption) caption.textContent = bubble.getAttribute('data-caption') || '';
    }
    function showTab(i) {
      active = i;
      tabs.forEach(function (t, j) {
        var on = j === i, acc = t.getAttribute('data-accent');
        t.style.background = on ? acc : 'rgba(255,255,255,.06)';
        t.style.color = on ? '#fff' : 'rgba(255,255,255,.7)';
        t.style.borderColor = on ? acc : 'rgba(255,255,255,.12)';
      });
      panels.forEach(function (p, j) {
        var on = j === i;
        p.style.display = on ? 'block' : 'none';
        var v = p.querySelector('[data-mt-video]');
        if (v && !on) { try { v.pause(); } catch (e) {} }
      });
      var panel = panels[i];
      if (panel) { var first = panel.querySelector('[data-mt-bubble]'); if (first) activateBubble(panel, first); }
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { showTab(i); }); });
    panels.forEach(function (p) { p.querySelectorAll('[data-mt-bubble]').forEach(function (b) { b.addEventListener('click', function () { activateBubble(p, b); }); }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) playVid(panels[active]); else { var v = panels[active] && panels[active].querySelector('[data-mt-video]'); if (v) { try { v.pause(); } catch (er) {} } } });
      }, { threshold: 0.25 }).observe(root);
    }
    showTab(0);
  };

  // ── Section: Marco flow (key "marcoflow") — THE Marco section ────────────
  // Pinned horizontal scroll through the topic screens (white bg). A tab-pill row
  // up top tracks the centred screen as you scroll AND is clickable to jump to a
  // screen; the heading + subtext swap to match the active screen. Generic — the
  // ride-mode flow boots the same handler.
  HeliosM.sections.marcoflow = function (root) {
    var MULT = 3.0;
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var rail = root.querySelector('[data-hm-apptrack]');
    if (!track || !sticky || !rail || !rail.children.length) return;
    var cards = [].slice.call(rail.children);
    var tabs = [].slice.call(root.querySelectorAll('[data-mf-tab]'));
    var dots = [].slice.call(root.querySelectorAll('.mf-dot'));
    var headEl = root.querySelector('[data-mf-head]');
    var subEl = root.querySelector('[data-mf-sub]');
    var cue = root.querySelector('[data-mf-cue]');
    var N = cards.length, lastIdx = -1;
    // place the "scroll to explore" peel straddling the top edge of the phone
    function placeCue() {
      if (!cue || !cards[0]) return;
      var band = rail.parentElement, phone = cards[0].firstElementChild;
      if (!band || !phone) return;
      // Use layout height (offsetHeight) × the fit scale — NOT getBoundingClientRect,
      // which is polluted by the per-card focus scale/translate during the scroll.
      // band.offsetTop + centring gap = the phone's top edge, stable across the pin.
      var phoneH = phone.offsetHeight * (cards[0]._fit || 1);
      var gap = (band.clientHeight - phoneH) / 2; if (gap < 0) gap = 0;
      cue.style.top = (band.offsetTop + gap - cue.offsetHeight / 2) + 'px';
      cue.style.opacity = '1';
    }
    function fitPhones() {
      var area = rail.parentElement; if (!area) return;
      var H = area.clientHeight; if (H < 140) return;
      var w = Math.min(300, window.innerWidth * 0.78);
      cards.forEach(function (c) { c._fit = 1; c.style.flex = '0 0 ' + w + 'px'; c.style.width = w + 'px'; c.style.transformOrigin = 'center center'; });
      cards.forEach(function (c) { var nat = c.offsetHeight; if (nat > H - 4) c._fit = (H - 4) / nat; });
    }
    function center() {
      var vw = window.innerWidth;
      rail.style.paddingLeft = Math.max(8, (vw - cards[0].offsetWidth) / 2) + 'px';
      rail.style.paddingRight = Math.max(8, (vw - cards[cards.length - 1].offsetWidth) / 2) + 'px';
    }
    function focus() {
      var mid = window.innerWidth / 2;
      cards.forEach(function (c) {
        var r = c.getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - mid) / (window.innerWidth * 0.62);
        var f = clamp(1 - d, 0, 1);
        var sc = lerp(0.9, 1.0, f) * (c._fit || 1);
        c.style.transform = 'translateY(' + ((1 - f) * 12) + 'px) scale(' + sc.toFixed(3) + ')';
        c.style.opacity = (0.4 + f * 0.6).toFixed(2);
      });
    }
    function setActive(idx) {
      if (idx === lastIdx) return; lastIdx = idx;
      dots.forEach(function (d, j) { d.classList.toggle('on', j === idx); });
      tabs.forEach(function (t, j) {
        var on = j === idx;
        t.style.background = on ? 'linear-gradient(135deg,#3f7bff,#1f54e0)' : 'rgba(255,255,255,.07)';
        t.style.color = on ? '#fff' : 'rgba(255,255,255,.72)';
        t.style.borderColor = on ? 'transparent' : 'rgba(255,255,255,.12)';
        t.style.boxShadow = on ? '0 10px 22px -9px rgba(32,94,238,.65)' : 'none';
        t.style.transform = on ? 'translateY(-1px)' : 'none';
      });
      var at = tabs[idx];
      if (at && at.parentElement && at.parentElement.scrollWidth > at.parentElement.clientWidth + 4) {
        var pr = at.parentElement, L = at.offsetLeft - (pr.clientWidth - at.offsetWidth) / 2;
        try { pr.scrollTo({ left: L, behavior: 'smooth' }); } catch (e) { pr.scrollLeft = L; }
      }
      var c = cards[idx]; if (!c) return;
      if (headEl) headEl.textContent = c.getAttribute('data-head') || '';
      if (subEl) subEl.textContent = c.getAttribute('data-sub') || '';
    }
    function scrollToIdx(i) {
      var h = window.innerHeight;
      var total = MULT * h - h;
      var ttop = track.getBoundingClientRect().top + window.scrollY;
      var p = N > 1 ? i / (N - 1) : 0;
      try { window.scrollTo({ top: ttop + p * total, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, ttop + p * total); }
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { scrollToIdx(i); }); });
    fitPhones(); center(); focus(); setActive(0); placeCue();
    setTimeout(function () { fitPhones(); center(); focus(); placeCue(); }, 300);
    setTimeout(placeCue, 700);
    window.addEventListener('resize', function () { fitPhones(); center(); focus(); placeCue(); });

    var curP = 0, curIdx = 0;
    pin(track, sticky, MULT, topOffset(), function (p) {
      var shift = Math.max(0, cards[cards.length - 1].offsetLeft - cards[0].offsetLeft);
      rail.style.transform = 'translateX(' + (-p * shift) + 'px)';
      focus();
      curP = p; curIdx = Math.round(p * (N - 1));
      setActive(curIdx);
    }, { cap: MAXSTAGE });

    // ── manual flick: swipe the phone left/right to step screens (keeps the scroll animation) ──
    // Drags translate the rail live; on release we snap by scrolling the page to that screen,
    // so the pin stays the single source of truth. touch-action:pan-y lets vertical page-scroll
    // (which drives the same animation) pass straight through.
    var band = rail.parentElement;
    if (band && window.PointerEvent) {
      band.style.touchAction = 'pan-y';
      var sx = 0, sy = 0, baseX = 0, axis = null, drag = false, shiftNow = 0;
      function snapTo(i) {
        i = clamp(i, 0, N - 1);
        var total = MULT * window.innerHeight - window.innerHeight;
        var ttop = track.getBoundingClientRect().top + window.scrollY;
        rail.style.transition = 'transform .34s cubic-bezier(.33,0,.2,1)';
        window.scrollTo(0, ttop + (N > 1 ? i / (N - 1) : 0) * total);   // instant; section is pinned so only the screen swaps
        setTimeout(function () { rail.style.transition = ''; }, 380);
      }
      band.addEventListener('pointerdown', function (e) {
        sx = e.clientX; sy = e.clientY; axis = null; drag = true;
        rail.style.transition = '';   // 1:1 live drag
        shiftNow = Math.max(0, cards[cards.length - 1].offsetLeft - cards[0].offsetLeft);
        baseX = -curP * shiftNow;
      });
      band.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (axis === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') { drag = false; return; }          // vertical → let the page scroll
        if (axis === 'x') {
          e.preventDefault();
          var x = clamp(baseX + dx, -shiftNow, 0);
          rail.style.transform = 'translateX(' + x + 'px)';
          focus();
          if (shiftNow > 0) setActive(Math.round((-x / shiftNow) * (N - 1)));
        }
      }, { passive: false });
      function endDrag(e) {
        if (!drag) return; drag = false;
        if (axis !== 'x') return;
        var dx = (e.clientX || sx) - sx, t = curIdx;
        if (dx < -40) t = curIdx + 1; else if (dx > 40) t = curIdx - 1;
        snapTo(t);
      }
      band.addEventListener('pointerup', endDrag);
      band.addEventListener('pointercancel', function () { drag = false; });
    }
  };

  // ── Section: Ride explore (key "rideexplore") — THE ride section ─────────
  // One oversized phone showing the real ride screen; the 8 actual buttons are
  // exploded into bubbles around it. Tap a bubble → its clip plays ON the phone +
  // the bubble lights + the caption updates. Tap ✕ → back to the map.
  HeliosM.sections.rideexplore = function (root) {
    var video = root.querySelector('[data-re-video]');
    var caption = root.querySelector('[data-re-caption]');
    var label = root.querySelector('[data-re-label]');
    var labelText = root.querySelector('[data-re-labeltext]');
    var closeBtn = root.querySelector('[data-re-close]');
    var bubbles = [].slice.call(root.querySelectorAll('[data-re-bubble]'));
    var defaultCap = caption ? caption.innerHTML : '';
    var current = null;
    function play() { if (!video) return; try { var p = video.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
    function activate(b) {
      current = b;
      // hide the controls so the clip plays clean full-screen on the phone
      bubbles.forEach(function (x) { x.style.opacity = '0'; x.style.pointerEvents = 'none'; });
      if (video) {
        var src = b.getAttribute('data-src');
        if (src && video.getAttribute('src') !== src) { video.setAttribute('src', src); try { video.load(); } catch (e) {} }
        video.style.opacity = '1';
        try { video.currentTime = 0; } catch (e) {}
        play();
      }
      if (labelText) labelText.textContent = b.getAttribute('data-label') || '';
      if (label) label.style.display = 'inline-flex';
      if (closeBtn) closeBtn.style.display = 'flex';
      if (caption) caption.textContent = b.getAttribute('data-caption') || '';
    }
    function reset() {
      current = null;
      bubbles.forEach(function (x) { x.style.opacity = '1'; x.style.pointerEvents = 'auto'; });
      if (video) { video.style.opacity = '0'; try { video.pause(); } catch (e) {} }
      if (label) label.style.display = 'none';
      if (closeBtn) closeBtn.style.display = 'none';
      if (caption) caption.innerHTML = defaultCap;
    }
    bubbles.forEach(function (b) { b.addEventListener('click', function () { activate(b); }); });
    if (closeBtn) closeBtn.addEventListener('click', reset);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!e.isIntersecting && video) { try { video.pause(); } catch (er) {} } else if (e.isIntersecting && current) play(); });
      }, { threshold: 0.2 }).observe(root);
    }
  };

  // ── Section: Pop-out (key "popout") — 3D coverflow with manual control ──
  // PINNED. King intro → the ride phone rises (carousel centre) → side cards FAN OUT into a
  // 3D ellipse and the row AUTO-SCROLLS. An icon strip below = one icon per screen: tap →
  // the carousel slides to that screen and STOPS. Thumb-drag the carousel left/right to land
  // on a screen too. Any interaction stops the auto-scroll.
  HeliosM.sections.popout = function (root) {
    var track = root.querySelector('[data-hm-track]');
    var sticky = root.querySelector('[data-hm-sticky]');
    var king = root.querySelector('[data-po-king]');
    var row = root.querySelector('[data-pc-row]');
    var cards = [].slice.call(root.querySelectorAll('.pc-card'));
    var vids = [].slice.call(root.querySelectorAll('[data-pc-video]'));
    var ctrls = [].slice.call(root.querySelectorAll('[data-rc-idx]'));
    var dock = root.querySelector('[data-rc-dock]');
    if (!track || !sticky || !row) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var N = cards.length;
    var GAP = 234, DEPTH = 120, SPREAD = 30, MAXA = 48;
    var pos = 0, vidsOn = false, fanNow = 0, raf = 0;
    var held = false, animating = false, targetPos = 0, lastActive = -1, buyBar = null;   // auto-scroll always runs unless a finger is held

    function layout(fan) {
      for (var i = 0; i < N; i++) {
        var rel = ((i - pos) % N + N) % N;     // [0,N)
        if (rel > N / 2) rel -= N;             // (-N/2, N/2]
        var a = Math.abs(rel);
        var ax = rel * GAP * fan;
        var az = -a * DEPTH * fan;
        var ry = clamp(-rel * SPREAD * fan, -MAXA, MAXA);
        var sc = clamp(1 - a * 0.11 * fan, 0.58, 1);
        var op = a < 0.5 ? 1 : clamp(1.12 - a * 0.27, 0, 1) * fan;
        var c = cards[i];
        c.style.transform = 'translate(-50%,-50%) translateX(' + ax.toFixed(1) + 'px) translateZ(' + az.toFixed(1) + 'px) rotateY(' + ry.toFixed(1) + 'deg) scale(' + sc.toFixed(3) + ')';
        c.style.opacity = op.toFixed(3);
        c.style.zIndex = String(Math.round(200 - a * 20 + rel));
      }
    }
    function updateCtrls() {
      if (!ctrls.length) return;
      var act = ((Math.round(pos) % N) + N) % N;
      if (act === lastActive) return; lastActive = act;
      for (var i = 0; i < ctrls.length; i++) ctrls[i].classList.toggle('on', i === act);
    }
    // anchor the dock just below the LIVE phone box every frame (survives URL-bar / layout shifts)
    function positionDock() {
      if (!dock) return;
      if (!buyBar) buyBar = document.querySelector('.exp5-sticky-cart, .hd-sticky-buy');
      var sb2 = sticky.getBoundingClientRect(), pb2 = row.getBoundingClientRect();
      var dt = (pb2.bottom - sb2.top) + 84;   // sit well clear below the on-phone name label (was +44 — too tight, clashed)
      // clamp so the strip's bottom clears the REAL sticky buy bar (whatever its live height)
      var barTop = buyBar ? (buyBar.getBoundingClientRect().top - sb2.top) : (sticky.clientHeight - 120);
      var maxT = barTop - 10 - dock.offsetHeight;
      if (dt > maxT) dt = maxT;
      dock.style.top = dt.toFixed(1) + 'px';
      var cf = clamp((fanNow - 0.4) / 0.4, 0, 1);
      dock.style.opacity = cf.toFixed(2);
      dock.style.pointerEvents = cf > 0.6 ? 'auto' : 'none';
    }
    function frame() {
      if (animating) {
        var d = targetPos - pos;
        if (Math.abs(d) < 0.004) { pos = targetPos; animating = false; }
        else pos += d * 0.18;
      } else if (!reduce && fanNow > 0.6 && !held) {
        pos = (pos + 0.0042) % N;
      }
      layout(fanNow);
      updateCtrls();
      positionDock();
      raf = requestAnimationFrame(frame);
    }
    function jumpTo(ti) {
      targetPos = ti + Math.round((pos - ti) / N) * N;   // nearest wrap of ti to current pos
      animating = true;                                  // ease to it, then auto-scroll resumes
    }

    function setVids(on) {
      if (on === vidsOn) return; vidsOn = on;
      vids.forEach(function (v) {
        if (on) { try { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } catch (e) {} }
        else { try { v.pause(); } catch (e) {} }
      });
    }

    function setPhase(p) {
      var kIn = clamp(p / 0.06, 0, 1), kOut = 1 - clamp((p - 0.24) / 0.10, 0, 1);
      if (king) { king.style.opacity = (kIn * kOut).toFixed(3); king.style.transform = 'translateY(' + ((1 - kIn) * 22 - (1 - kOut) * 14) + 'px)'; }
      var g1 = clamp((p - 0.36) / 0.14, 0, 1);
      var sc = lerp(0.78, 1.0, g1);
      var ty = lerp(96, 14, g1);
      row.style.transform = 'translateY(' + ty.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')';
      var fan = clamp((p - 0.52) / 0.18, 0, 1);
      fanNow = fan;
      layout(fan);
      if (king) {
        var stb = sticky.getBoundingClientRect(), prb = row.getBoundingClientRect();
        king.style.top = Math.max(6, (prb.top - stb.top) - king.offsetHeight - 26) + 'px';
      }
      positionDock();
      setVids(fan > 0.35);
    }

    // ── icon tap → jump to that screen + stop ──
    var suppressClick = false;
    ctrls.forEach(function (b, i) {
      b.addEventListener('click', function () { if (suppressClick || fanNow < 0.5) return; jumpTo(i); });
    });

    // ── thumb-drag the carousel left/right (only when open; vertical scroll passes through) ──
    var sx = 0, sy = 0, axis = null, dragBase = 0, dragActive = false;
    sticky.addEventListener('pointerdown', function (e) {
      if (fanNow < 0.6) return;
      sx = e.clientX; sy = e.clientY; axis = null; dragActive = true; dragBase = pos;
      held = true; animating = false;   // finger down → hold (pauses the auto-scroll)
    });
    sticky.addEventListener('pointermove', function (e) {
      if (!dragActive) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (axis === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (axis === 'y') { dragActive = false; held = false; return; }   // it's a page scroll, not a carousel hold
      if (axis === 'x') {
        e.preventDefault();
        pos = dragBase - dx / GAP;
        layout(fanNow); updateCtrls();
      }
    }, { passive: false });
    function release() {
      if (axis === 'x') { suppressClick = true; setTimeout(function () { suppressClick = false; }, 60); }
      held = false; dragActive = false;   // finger up → resume auto-scroll from here (no snap)
    }
    sticky.addEventListener('pointerup', release);
    sticky.addEventListener('pointercancel', release);

    layout(0); updateCtrls();
    if (!raf) raf = requestAnimationFrame(frame);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { setVids(e.isIntersecting && fanNow > 0.35); });
      }, { threshold: 0.05 }).observe(root);
    }
    pin(track, sticky, 3.6, topOffset(), function (p) { setPhase(p); }, { cap: MAXSTAGE });
    setPhase(0);
  };

  // ── Section: Butter tools (key "buttertools") — horizontal carousel candidate ──
  HeliosM.sections.buttertools = function (root) {
    var track = root.querySelector('[data-bt-track]');
    var dots = [].slice.call(root.querySelectorAll('.bt-dot'));
    var cards = track ? [].slice.call(track.children) : [];
    if (!track || !cards.length) return;
    var raf = 0;
    function update() {
      raf = 0;
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
      cards.forEach(function (c, i) { var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid); if (d < bestD) { bestD = d; best = i; } });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === best); });
    }
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  };

  // ── Boot ─────────────────────────────────────────────────────────────
  function boot() {
    document.querySelectorAll('[data-hm-section]').forEach(function (root) {
      if (root.dataset.hmBooted) return;
      if (root.offsetParent === null) return;   // skip hidden sections (e.g. the display:none mobile copy on desktop)
      var key = root.getAttribute('data-hm-section');
      var fn = HeliosM.sections[key];
      if (typeof fn === 'function') { root.dataset.hmBooted = '1'; try { fn(root); } catch (e) { if (window.console) console.warn('helios-m ' + key, e); } }
    });
  }
  HeliosM.boot = boot;
  HeliosM._booted = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // model-viewer / cardart may load after this; re-boot once they're ready.
  window.addEventListener('load', boot);
})();
